import { useEffect, useState } from 'react';

import { Content } from './timer.styled';

let timer = null;

export const Timer = () => {
  const [sec, setSec] = useState(0);

  useEffect(() => {
    timer = window.setInterval(() => {
      setSec((sec) => sec + 1);
    }, 1000);

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, []);

  const getTimeEl = () => {
    let minutes = null;
    let seconds = sec;
    minutes = Math.floor(seconds / 60);
    if (minutes < 10) {
      minutes = '0' + minutes;
    }
    seconds = seconds - minutes * 60;
    if (seconds < 10) {
      seconds = '0' + seconds;
    }
    return minutes + ':' + seconds;
  };

  const timeEl = getTimeEl();

  return <Content>{timeEl}</Content>;
};
